export default {
    CLIPBOARD_CANCEL_DELETE_DIALOG: 'clipboard-cancel-delete-dialog',
    CLIPBOARD_CANCEL_REPEAT_MODAL: 'clipboard-cancel-repeat-modal',
    CLIPBOARD_CLEAR_SELECTED_SESSIONS: 'clipboard-clear-selected-sessions',
    CLIPBOARD_COPY_SELECTED_SESSIONS: 'clipboard-copy-selected-sessions',
    CLIPBOARD_DISABLE_CALENDAR_HOTKEYS: 'clipboard-disable-calendar-hotkeys',
    CLIPBOARD_ENABLE_CALENDAR_HOTKEYS: 'clipboard-enable-calendar-hotkeys',
    CLIPBOARD_ENABLE_DELETE_DIALOG: 'clipboard-enabled-delete-dialog',
    CLIPBOARD_ENABLE_EXPORT_AS_PROGRAM_MODAL:
        'clipboard-enable-export-as-program-modal',
    CLIPBOARD_ENABLE_REPEAT_MODAL: 'clipboard-enable-repeat-modal',
    CLIPBOARD_SELECT_SESSIONS: 'clipboard-select-sessions',
    TOAST: 'toast'
};



// WEBPACK FOOTER //
// ./src/state/reducer/clipboard/actions.js